import { createContext, useContext } from "react"
import { useMotionValue } from "framer-motion"

import { getSelected, PARAM_KEY_CATEGORY, PARAM_KEY_FILTER } from "./utils"

export const Context = createContext()

export const SGProvider = ({ children }) => {
  const cols = useMotionValue(1)
  const category = useMotionValue(getSelected(PARAM_KEY_CATEGORY, "all"))
  const avail_category = useMotionValue(null)
  const filter = useMotionValue(getSelected(PARAM_KEY_FILTER, "all"))
  const avail_filter = useMotionValue(null)
  const VH = useMotionValue(0)
  const T = useMotionValue(Infinity)
  const filtering = useMotionValue(0)
  const range = useMotionValue(1)
  const straight = useMotionValue(0)

  return <Context.Provider value={{ cols, filtering, category, avail_category, filter, avail_filter, VH, T, range, straight }}>{children}</Context.Provider>
}

export const useSG = () => useContext(Context)
